// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__KwTVW","fadeIn":"Modal_fadeIn__99O-3","modal":"Modal_modal__gXta9"};